type Props = {
    children?: React.ReactNode;
    scene: string;
    colorName: string;
    isSelected: boolean;
    onClick?: () => void;
    disabled?: boolean;
    animationClass?: string;
    label?: string;
    id?: string;
};

const Button: React.FC<Props> = ({
    children,
    scene,
    colorName,
    isSelected,
    onClick,
    disabled = false,
    animationClass,
    label,
    id,
}) => {
    return (
        <div
            className={`button button__${scene} ${animationClass} ${
                isSelected
                    ? `button__${scene}--${colorName}--selected`
                    : `button__${scene}--${colorName}`
            } 


      
      ${disabled ? 'button--disabled' : ''}`}
            onClick={!disabled ? onClick : undefined}
            aria-label={label || `button--${scene}`}
            id={id}
        >
            {children}
        </div>
    );
};

export default Button;
